package ui.external.materialui

object Color {
    const val primary = "primary"
    const val secondary = "secondary"
    const val inherit = "inherit"
}
